import type { ReportingDashboardDTO, PresignedReportingDashboardDTO } from 'src/portal-bff-api';

import { useQuery } from '@tanstack/react-query';

import { SigmaApi } from 'src/portal-bff-api/apis/sigma-api';

import { useApiConfig, useWithPreMiddleware } from './use-api-config';

// ----------------------------------------------------------------------

export const useSigmaApi = () => {
  const config = useApiConfig();
  const baseApi = new SigmaApi(config);

  return useWithPreMiddleware(baseApi);
};

export const useSigmaDashboards = () => {
  const { api } = useSigmaApi();

  return useQuery<ReportingDashboardDTO[], Error>({
    queryKey: ['sigma', 'dashboards'],
    queryFn: () => api.getReportingDashboards(),
    refetchOnWindowFocus: false,
  });
};

export const useSigmaDashboardBySlug = (slug: string) => {
  const { data: dashboards = [] } = useSigmaDashboards();
  const dashboard = dashboards.find((d) => d.slug === slug);
  const alias = dashboard?.alias || '';

  const { api } = useSigmaApi();

  return useQuery<PresignedReportingDashboardDTO, Error>({
    queryKey: ['sigma', 'dashboard-by-slug', slug, alias],
    queryFn: () =>
      api.getPresignedReportingDashboard({
        dashboardAlias: alias,
      }),
    enabled: !!alias,
    refetchOnWindowFocus: false,
  });
};
